import React, { useCallback, useEffect, useState } from 'react';

import { AnimatePresence } from 'framer-motion';

import { Modal } from '@pkg/components/Modal';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { setUserAutoGenerateProfile } from '@app/store/actions/user';
import { updateAutoProfile } from '@app/store/slices/yat-page';

import { RadioGroup, Settings } from './RadioGroup';

import {
    ButtonWrapper,
    ContentHeading,
    ContentWrapper,
    CTAButton,
    Heading,
    HeadingWrapper,
    SubHeading,
} from './DepSettingsModal.style';

export interface DepSettingsModalProps {
    onClose(): void;
    isOpen: boolean;
}

export const DepSettingsModal = ({ onClose, isOpen }: DepSettingsModalProps) => {
    const dispatch = useAppDispatch();
    const autoProfileSetting = useAppSelector((state) => state.yatPage.autoProfileSetting);

    const [selected, setSelected] = useState(autoProfileSetting ? Settings.auto : Settings.manual);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setSelected(autoProfileSetting ? Settings.auto : Settings.manual);
    }, [autoProfileSetting, setSelected]);

    const handleSave = useCallback(() => {
        setIsLoading(true);
        dispatch(setUserAutoGenerateProfile(selected === Settings.auto)).then((r) => {
            if (r.ok) {
                const value = r.value?.value;
                dispatch(updateAutoProfile(value));
            }
            onClose();
            setIsLoading(false);
        });
    }, [dispatch, selected, onClose]);

    return (
        <AnimatePresence mode="wait">
            {isOpen && (
                <Modal onClose={onClose}>
                    <HeadingWrapper>
                        <Heading>Settings</Heading>
                        <SubHeading>Exclusive options to customise and update your web3 profile.</SubHeading>
                    </HeadingWrapper>

                    <ContentWrapper>
                        <ContentHeading>Updates</ContentHeading>
                        <ButtonWrapper>
                            <RadioGroup selected={selected} setSelected={setSelected} />
                        </ButtonWrapper>
                        <CTAButton loading={isLoading} onClick={handleSave} size="large">
                            Save
                        </CTAButton>
                    </ContentWrapper>
                </Modal>
            )}
        </AnimatePresence>
    );
};
